import { PayableSubject } from '../../paymentReconciliationModal/types'

export const getSubjectBalanceSum = <T extends PayableSubject>(subjects: T[]) =>
  subjects?.reduce((sum: number, bill: T) => {
    return sum + (bill?.balance || 0)
  }, 0)
